// Calendar dates (YYYY-MM-DD) are never converted through UTC; "today" is computed in the CRM timezone.
let TZ = "America/Toronto";
export const setTimezone = (tz) => { if (tz) TZ = tz; };
export const getTimezone = () => TZ;

const ymd = (d) => {
  const m = /^(\d{4})-(\d{2})-(\d{2})/.exec(String(d || ""));
  return m ? [Number(m[1]), Number(m[2]), Number(m[3])] : null;
};

export const todayISO = () => new Date().toLocaleDateString("en-CA", { timeZone: TZ });

export function daysUntil(d) {
  const a = ymd(d), t = ymd(todayISO());
  if (!a || !t) return null;
  return Math.round((Date.UTC(...[a[0], a[1] - 1, a[2]]) - Date.UTC(t[0], t[1] - 1, t[2])) / 86400000);
}

export function fmtDay(d, opts = { day: "2-digit", month: "short", year: "numeric" }) {
  const a = ymd(d);
  if (!a) return "Not set";
  return new Date(Date.UTC(a[0], a[1] - 1, a[2])).toLocaleDateString(undefined, { ...opts, timeZone: "UTC" });
}
